import React from 'react';

import { useTheme } from 'styled-components';

import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';

import { Container } from './styles';

import { ItemProps } from './interface';

const GridHeadItem: React.FC<ItemProps> = ({
  title,
  width,
  onClick,
  active,
  order,
  children,
}) => {
  const { colors } = useTheme();

  return (
    <Container active={active} width={width} onClick={onClick}>
      {title ? <span>{title}</span> : null}
      {active ? (
        <i>
          {order === 'desc' ? (
            <IoMdArrowDropup size={22} color={colors.IC1} />
          ) : (
            <IoMdArrowDropdown size={22} color={colors.IC1} />
          )}
        </i>
      ) : null}
      <>{children}</>
    </Container>
  );
};

export default GridHeadItem;
